import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Input } from '@angular/core';
import { Router, Event, Scroll } from '@angular/router';

import { Notification, NotificationType } from '../../model/notification';
import { HisNotificationService } from '../../service/notifications/his-notification.service';

@Component( {
    selector: 'his-notification',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class NotificationsComponent implements OnInit {

    private notificationService = inject(HisNotificationService);
    private router = inject(Router);

    notifications: Notification[] = new Array<Notification>();

    isNotificationButtonActive = false;

    counterBounce = false;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    NotificationType = NotificationType;


    // delete all Notifications if the route changes?
    @Input() clearOnRouteChange = true;

    constructor() {
        if ( this.clearOnRouteChange ) {
            // subscribe to ervery router event
            this.router.events.subscribe( (event: Event) => {
                // if route changes remove all notifications
                if(this.isEventValid(event)) {
                    this.removeAllNotifications();
                }
            } );
        }
    }

    ngOnInit() {
        // subscribe to notifications
        this.notificationService
            .getNotification()
            .subscribe( ( notification: Notification ) => {
                if ( !notification ) {
                    // clear notfications when an empty notification is received
                    this.notifications = [];
                    return;
                }
                // add notification to array
                this.notifications.push( notification );
            } );
    }

    showNotificationButton() {
        this.isNotificationButtonActive = true;
    }

    hideNotificationButton() {
        this.isNotificationButtonActive = false;
    }

    // hide Notification on Screen and display the Button to show again
    hideNotification( notification: Notification ) {
        notification.state = 'hidden';
        this.showNotificationButton();
        this.triggerCounterBounce();
    }
	
    private triggerCounterBounce() {
        this.counterBounce = false;
        requestAnimationFrame(()=> {this.counterBounce=true;});
    }
	
    removeAllNotifications() {
        this.notificationService.clear();
        this.hideNotificationButton();
    }

    // get all Notifications, which are not hidden
    getNotifications(): Notification[] {
        return this.notifications.filter( notification => {
            return notification.state !== 'hidden';
        } );
    }

    // show every notification (set all hidden notificatoins to 'showagain')
    showAll() {
        this.notifications.forEach( notification => {
            if ( notification.state === 'hidden' ) {
                notification.state = 'showagain';
                notification.visible = true;
            }
        } );
        this.hideNotificationButton();
    }

    // get the number of hidden Notifications
    countOfHiddenNotifications(): number {
        return this.notifications.filter( ( notification ) => {
            return notification.state === 'hidden';
        } ).length;
    }

    // get the visibility state of the counter
    isCounterVisible(): boolean {
        return this.countOfHiddenNotifications() > 0;
    }

    // filter ScrollEvents
    private isEventValid(event: Event): boolean {
        return !(event instanceof Scroll);
    }
}
